import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import {
  Feature,
  FeatureNames,
  HolidayProgramCommands,
  HolidayProgramProperties,
} from '@vi-iot/client';

import { FeatureService, InstallationFeaturesStore } from '@store';

@Component({
  selector: 'app-holiday-icon',
  templateUrl: './holiday-icon.component.html',
  styleUrls: ['./holiday-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HolidayIconComponent implements OnInit {
  @Input() isMultiFamily = false;

  holiday$: Observable<Feature<HolidayProgramProperties, HolidayProgramCommands>>;
  holidayAtHome$: Observable<Feature<HolidayProgramProperties, HolidayProgramCommands>>;

  constructor(
    public featureService: FeatureService,
    private installationFeaturesStore: InstallationFeaturesStore
  ) {}

  ngOnInit(): void {
    this.holiday$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitSingleFamilyHolidayProgram
    );

    this.holidayAtHome$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.circuitSingleFamilyHolidayAtHome
    );
  }
}
